import React from "react";
import Header from "~/components/Header";
import ModelView from "~/components/ModelView";
import ChatHistory from "~/components/chat/ChatHistory";
import ControlButton from "~/components/ControlButton";

interface ChatPageLayout1Props {
  isSettingOpen: boolean;
  isStandbymode: boolean;
}

const ChatPageLayout1: React.FC<ChatPageLayout1Props> = ({ isSettingOpen, isStandbymode }) => {
  return (
    <>
      <Header />
      <div className={`main-contents  main-contents-layout-1 ${isSettingOpen ? "open" : ""}`}>
        <div className="sub-contents sub-contents-layout-1">
          <ModelView visible={!isStandbymode} />
          <div className="chat-space">
            <div className="chat-container">
              <ChatHistory />
            </div>
          </div>
        </div>
        <ControlButton />
      </div>
    </>
  );
};

export default ChatPageLayout1;
